const MenuItem = (_props) => null;
MenuItem.displayName = "@mantine/core/MenuItem";

export { MenuItem };
//# sourceMappingURL=MenuItem.js.map
